module.exports = __webpack_public_path__ + "img/31.10e799bf.png";